const MenuOperator = [
  {
    path: "dashboard",
    icon: "fas fa-globe text-green",
    title: "aippsolute.com",
  },
	{
		path: "/Users",
		icon: "fa fa-address-book text-lime",
		title: "Users",
		children: [
			{ path: "/user/contacts", title: "Contacts" },			
			
		],
	},

  {
    path: "/AIML",
    icon: "far fa-brain text-gray",
    title: "AIML",
    children: [
	 { path: "/AIML/ImageAnnotations", title: "Settings" }, 
	 { path: "/AIML/chats", title: "chats" },
	 { path: "/AIML/ImageAnnotations", title: "Text Annotation" },	
	 { path: "/AIML/ImageAnnotations", title: "Videos Annotation" },
	 { path: "/AIML/ImageAnnotations", title: "Audios Annotation" },	    
         { path: "/AIML/ImageAnnotations", title: "Data Annotation" },	
         { path: "/AIML/ImageAnnotations", title: "Images Annotation" },
         { path: "/metai/yourdrive", title: "Data Training" },	    
         { path: "/AIML/APIs", title: "APIs" },	        	    
         { path: "/AIML", title: "AI Service Providers List" },
         { path: "/AIML", title: "AI Service Providers" },
         { path: "/AIML", title: "AIssistants" },	        
         { path: "/AIML", title: "AIML Tasks" },	  
         { path: "/drive/yourdrive", title: "Your Drive" },	    
         { path: "AIML/LabelStudio", title: "Label Studio" },
    ],
  },	

  {
    path: "/workinstructions", icon: "fa fa-briefcase text-teal", title: "Work Instructions",
    children: [
      { path: "/workinstructions/ALUInbound", title: "MN-NI-Inbound" },
      { path: "/workinstructions/ALUOutbound", title: "MN-NI-Outbound" },
      { path: "/workinstructions/ALUOutboundCheatSheet", title: "ALU-Outbound-CheatSheet" },				
      { path: "/workinstructions/RLC", title: "RLC" },
      { path: "/workinstructions/RLCGoodsReceive", title: "RLC Goods Receive" },
      { path: "/workinstructions/OTM", title: "OTM" },
	  { path: "/workinstructions/password", title: "Password" },	
      { path: "/workinstructions/Shipment", title: "Shipment" },	
	  { path: "/workinstructions/VL09", title: "VL09" },
 	  { path: "/workinstructions/confirmationdeliveries", title: "Confirmation of Deliveries" },	
 	  { path: "/workinstructions/printerconfiguration", title: "PrinterConfiguration" },
      { path: "/workinstructions/OutboundGDC", title: "Outbound Nokia MN" },
      { path: "/workinstructions/workinstructions/new", title: "Add New WorkInstruction" },
      { path: "/workinstructions/workinstructions/", title: "Work Instructions List" },      		
//      { path: "/workinstructions/erinstructions/", title: "ER Instructions List" },
//      { path: "/workinstructions/erinstructions/new", title: "Add New ER Instruction" },
    ],
  },
	
  {
    path: "/QESH",
    icon: "fa fa-qesh-custom",
    title: "QESH",
    children: [
      { path: "/QESH/capas", title: "CAPAs" },
      { path: "/QESH/CAPAFormISO", title: "CAPAFormIso" },	    	    
    ],
  },	
	
  {
    path: "/label",
    icon: "fa fa-barcode text-cyan",
    title: "Barcode & Label",
    children: [
      { path: "/label/labels", title: "Labels" },
      { path: "/label/labels", title: "Input item" },

      { path: "/label/labelprint", title: "Print Label" },

//      { path: "/label/imageAnnotations", title: "Images Annotation" },	    
    ],
  },	
  {
    path: "/ERP",
    icon: "fa fa-ERP1-custom text-mint",
    title: "ERP",
    children: [
       { path: "/ERP/COOItems", title: "Input new Item by Camera" },	    
       { path: "/ERP/COOItems", title: "COOItems" },
       { path: "/ERP/COOitemsxls", title: "COO Items XLS" },	    	    
       { path: "/ERP/RVSs", title: "Repair Vendors Supplier List" },
       { path: "/ERP/outerboxbarcodeimages", title: "Outerbox codes" }    ],
  },	
	
  {
    path: "/yourdrive",
    icon: "fa fa-cloud text-pink",
    title: "Yourdrive",
    children: [
      { path: "/yourdrive/yourdrive", title: "Your Drive" },
      { path: "/yourdrive/search_yourdrive", title: "Search in your drive" },
    ],
  },

  {
    path: "/Forum",
    icon: "fas fa-ticket-alt text-olive",
    title: "Forums",
    badge: "10",
    children: [ 
      { path: "/forum/forums", title: "Forums" },	   
    ],
  },
  
  {
    path: "/Ticket",
    icon: "fas fa-ticket-alt text-olive",
    title: "Tickets",
//    badge: "10",
    children: [
      { path: "/ticket/tickets", title: "Tickets" },
      { path: "/ticket/tickets/new", title: "Add Ticket" },
      { path: "/ticket/grid-tickets", title: "Gridview of Tickets" },
      { path: "/ticket/timelinetickets", title: "Timeline of Tickets" },
      { path: "/ticket/search_tickets", title: "Search in Tickets" },

    ],
  },

];

export default MenuOperator;

















